import React from 'react'
import { useMutation } from '@apollo/client'
import { UpdateCustomerDocument } from '../graphql/__generated__'
import type { ApolloError } from '@apollo/client'

type FlagInfo = {
  createdAt: unknown
  createdByName: string
  createdByEmail: string
  description?: string | null
  emoji?: ReadonlyArray<string> | string[] | null
}

interface FlagButtonProps {
  customerId: string | undefined
  flag: FlagInfo | null | undefined
}

const FlagButton = ({ customerId, flag }: FlagButtonProps) => {
  const [updateCustomer, { loading, data, error }] = useMutation(UpdateCustomerDocument, {
    onError: (error: ApolloError) => {
      console.error("Error unflagging", error)
    }
  })

  if (!flag) {
    return <></>
  }

  const createdAtDate = new Date(flag.createdAt as string | number | Date)

  function unflag() {
    updateCustomer({
      variables: {
        customerID: customerId,
        fields: ['flagOrders'],
        prevValues: {
          flagOrders: flag as any,
        },
        newValues: {
          flagOrders: null,
        }
      }
    })
  }

  let emoji = flag.emoji
  if (!emoji) {
    emoji = ["🚩"]
  }

  let buttonValue: React.ReactNode =
    <span className="text-2xl">{ emoji.join(' ') }</span>
  if (loading) {
    buttonValue = "S"
  } else if (error) {
    buttonValue = "E"
  } else if (data) {
    buttonValue = ""
  }

  return <button title={`Flagged by ${ flag.createdByName } at ${ createdAtDate.toLocaleDateString() }`} onClick={ unflag }>
    { buttonValue }
  </button>
}

export default FlagButton
